import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import {
  Modal,
  Alert,
  Transfer,
  Table,
  Button,
  Switch,
  Row,
  Col,
  Card,
} from "antd";
import difference from "lodash/difference";
import ModalCfop from "./modal";
import DrawerMovement from "./drawer";
import { numberToReal, isNull } from "../../../../helpers/functions";
import { createLoadingSelector } from "../../../../store/api/selectors";
import {
  deleteResult,
  changeRecipeCfop,
  acceptRouding,
  acceptDivergence,
  setDiscount,
  setFreight,
  setDevolution,
  setAddition,
  setOutrasDespesas
} from "../actions";

const columns = [
  {
    title: "CFOP",
    dataIndex: "cfop",
    align: "center",
  },
  {
    title: "Grupo",
    dataIndex: "grupo",
    align: "center",
  },
  {
    title: "Valor",
    dataIndex: "valor",
    align: "right",
  },
  {
    title: "Valor de Desconto",
    dataIndex: "valorDesconto",
    align: "right",
  },
  {
    title: "Valor de Frete",
    dataIndex: "valorFrete",
    align: "right",
  },
  {
    title: "Valor de Acréscimo",
    dataIndex: "ValorAcrescido",
    align: "right",
  },
  {
    title: "Valor de Outras Despesas Acessórias",
    dataIndex: "ValorOutrasDespesas",
    align: "right",
  },
  {
    title: "Valor Total",
    dataIndex: "valorTotal",
    align: "right",
  },
];

let newList = [];

class Cfop extends Component {
  constructor() {
    super();
    this.state = {
      targetKeys: [],
      selectedRowKeys: [],
      modalCancel: false,
      modalRouding: false,
      modalDivergence: false,
      modalBlockDeclardaMaior: false,
      visibleDrawer: false,
      request: "DELETE_PRODUCT",
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    this.setState({ id: id });

    this.createNewList();
  }

  componentDidUpdate(prevProps) {
    const cnpj = JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj,
      { statusDelete } = this.props;

    if (prevProps.data !== this.props.data) {
      this.createNewList();
    }

    if (statusDelete === 200) {
      this.props.history.push(`/empresa/${cnpj}`);
    }
    // else if (statusDelete !== 200 && statusDelete) {
    //   message.error("Ops... ocorreu um erro ao interromper a apuração");
    // }
  }

  createNewList() {
    let outrasReceitas = null;
    if (!isNull(this.props.data)) {
      if (!isNull(this.props.data.tributosResultadoPisCofins)) {
        outrasReceitas = this.props.data.tributosResultadoPisCofins.find(
          (value) => value.Status === 10
        );
      }
    }

    let {
      data,
      data: { CfopMovimentacao },
    } = this.props;

    if (!isNull(data) && !isNull(outrasReceitas)) {
      CfopMovimentacao.push({
        Cfop: "",
        ConsideraReceita: true,
        Grupo: "OUTRAS RECEITAS",
        Situacao: "",
        Totalizador: "",
        Valor: outrasReceitas.ValorParcela,
        ValorDesconto: 0,
        ValorFrete: 0,
        ValorAcrescido: outrasReceitas.ValorAcrescido,
        ValorOutrasDespesas: outrasReceitas.ValorOutrasDespesas,
        ValorTotal: outrasReceitas.ValorParcela,
      });
    }

    let listNotRecipe = null;

    newList = CfopMovimentacao?.map((item) => {
      return {
        key: item.Cfop + "-" + Math.floor(Math.random() * 1000).toString(),
        cfop: item.Cfop ? item.Cfop : "-",
        valor: numberToReal(item.Valor),
        valorDesconto: numberToReal(item.ValorDesconto),
        valorFrete: numberToReal(item.ValorFrete),
        ValorAcrescido: numberToReal(item.ValorAcrescido),
        ValorOutrasDespesas:numberToReal(item.ValorOutrasDespesas),
        valorTotal: numberToReal(item.ValorTotal),
        grupo: item.Grupo,
        consideraReceita: item.ConsideraReceita,
        disabled:
          item.Grupo === "60D" ||
          item.Grupo === "TDM" ||
          item.Grupo === "61R" ||
          item.Grupo === "C425" ||
          item.Grupo === "OUTRAS RECEITAS"
            ? true
            : false,
      };
    });

    listNotRecipe = newList
      ?.filter((item) => !item.consideraReceita)
      .map((item) => item.key);

    this.setState({ targetKeys: listNotRecipe });
  }

  handleChange = (nextTargetKeys, direction) => {
    const data = { Id: this.state.id },
      tempDiff = [];

    this.setState({ targetKeys: nextTargetKeys });

    if (direction === "right") {
      data.Diff = nextTargetKeys.filter(
        (x) => !this.state.targetKeys.find((y) => x === y)
      );
    } else {
      data.Diff = this.state.targetKeys.filter(
        (x) => !nextTargetKeys.find((y) => x === y)
      );
    }

    data.Diff.forEach((elem) => tempDiff.push(elem.split("-")[0]));
    data.Diff = tempDiff;

    this.props.changeRecipeCfop(data);
  };

  openModal(key) {
    let name;

    if (key === 1) name = "modalCancel";
    else if (key === 2) name = "modalRouding";
    else if (key === 3) name = "modalDivergence";
    else if (key === 4) name = "modalBlockRouding";
    else if (key === 5) name = "modalBlockDeclardaMaior";

    this.setState({ [name]: true });
  }

  closeModal(key) {
    let name;
    if (key === 1) name = "modalCancel";
    else if (key === 2) name = "modalRouding";
    else if (key === 3) name = "modalDivergence";
    else if (key === 4) name = "modalBlockRouding";
    else if (key === 5) name = "modalBlockDeclardaMaior";

    this.setState({ [name]: false });
  }

  modalWarning = () => {
    Modal.warning({
      title: "Atenção",
      content: (
        <span>
          A receita total declarada no PGDAS-D está diferente da receita total
          apurada pelo e-Recuperador. Alertamos que, no caso de retificação da
          declaração com o valor apurado pelo sistema, a alteração no valor de
          receita de meses anteriores provoca alteração na receita bruta
          acumulada nos 12 meses anteriores ao período de apuração (RBT12),
          utilizada para definir a alíquota nominal e efetiva, e isso pode
          acarretar a geração de DAS complementar. Agora você tem 4 (quatro)
          opções: <br />
          <br />
          <strong>1)</strong> Realizar os ajustes na lista de CFOP
          representativos de receitas até que as receitas declarada e apurada
          fiquem iguais. <br />
          <strong>2)</strong> Interromper a apuração. <br />
          <strong>3)</strong> Manter a divergência entre a receita total
          declarada no PGDAS-D e a receita total apurada pelo e-Recuperador,
          mesmo ciente dos riscos de retificar o valor da receita (neste caso, o
          sistema gerará apenas a planilha de detalhamento das receitas, não
          realizando a apuração do crédito ou os valores para retificação do
          PGDAS-D). <br />
          <strong>4)</strong> Concordar que o sistema considere a receita total
          originalmente declarada no PGDAS-D e prosseguir com a apuração (neste
          caso, a retificação da declaração não alterará a receita anteriormente
          declarada). Esta é a opção mais conservadora.
        </span>
      ),
      centered: true,
      width: 900,
    });
  };

  showPendenciaDrawer = () => {
    this.setState({
      visibleDrawer: true,
    });
  };

  onPendenciaClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    const {
      isFetching,
      data,
      data: {
        DuplicidadeMovimentacao,
        resultadoPisCofins: {
          ConsiderarDesconto,
          ConsiderarDevolucao,
          ConsiderarFrete,
          ValorTotalDevolucao,
          ValorTotalOutrasDespesas,
          ValidarNfe,
          ValidarNfce,
          ConsiderarValorAcrescido,
          ConsiderarOutrasDespesas
        },
      },
    } = this.props;
    const {
      targetKeys,
      modalCancel,
      modalRouding,
      modalDivergence,
      modalBlockRouding,
      modalBlockDeclardaMaior,
      id,
    } = this.state;

    const TableTransfer = ({ leftColumns, rightColumns, ...restProps }) => (
      <Transfer {...restProps} showSelectAll={false}>
        {({
          direction,
          filteredItems,
          onItemSelectAll,
          onItemSelect,
          selectedKeys: listSelectedKeys,
          disabled: listDisabled,
        }) => {
          const columns = direction === "left" ? leftColumns : rightColumns;

          const rowSelection = {
            getCheckboxProps: (item) => ({
              disabled: listDisabled || item.disabled,
            }),
            onSelectAll(selected, selectedRows) {
              const treeSelectedKeys = selectedRows
                .filter((item) => !item.disabled)
                .map(({ key }) => key);
              const diffKeys = selected
                ? difference(treeSelectedKeys, listSelectedKeys)
                : difference(listSelectedKeys, treeSelectedKeys);
              onItemSelectAll(diffKeys, selected);
            },
            onSelect({ key }, selected) {
              onItemSelect(key, selected);
            },
            selectedRowKeys: listSelectedKeys,
          };
          
          return (
            <Table
              rowSelection={rowSelection}
              columns={columns}
              dataSource={filteredItems}
              rowKey={(record) => record.key}
              size="small"
              loading={isFetching ? true : false}
              onRow={({ key, disabled: itemDisabled }) => ({
                onClick: () => {
                  if (itemDisabled || listDisabled) return;
                  onItemSelect(key, !listSelectedKeys.includes(key));
                },
              })}
            />
          );
        }}
      </Transfer>
    );

    const messageWarning = (
      <span>
        A receita total declarada no PGDAS-D está diferente da receita total
        apurada pelo e-Recuperador.
        <Button type="link" onClick={this.modalWarning}>
          Saiba mais
        </Button>
      </span>
    );

    return (
      <div className="cfop">
        <Alert message={messageWarning} type="warning" showIcon closable />

        {modalCancel ? (
          <ModalCfop
            type="danger"
            modalKey={1}
            title="Interromper apuração"
            caption="Esta opção irá interromper o processo de apuração, apagando os dados desta competência."
            okText="Ok"
            visible={modalCancel}
            closeModal={this.closeModal}
            action={this.props.deleteResult}
            isFetching={isFetching}
          />
        ) : null}

        {modalRouding ? (
          <ModalCfop
            type="primary"
            modalKey={2}
            title="Prosseguir com a apuração do crédito considerando a receita total originalmente declarada no PGDAS-D"
            caption="Ao considerar a receita declarada no PGDAS-D, você tem ciência e concorda que o sistema fará uma adequação na segregação de receitas com visão conservadora. Se a receita declarada no PGDAS-D for maior que a receita apurada, a diferença será incluída nas receitas sem substituição tributária/tributação monofásica/antecipação com encerramento de tributação (significa que, no resultado gerado, a diferença a maior será tributada integralmente). Caso contrário, se a receita declarada no PGDAS-D for menor que a receita apurada, a diferença será subtraída das receitas com substituição tributária/tributação monofásica/antecipação com encerramento de tributação (significa que, no resultado gerado, a diferença a menor será subtraída da parcela não tributada, reduzindo, consequentemente, o montante de crédito a ser restituído)."
            okText="Prosseguir"
            visible={modalRouding}
            closeModal={this.closeModal}
            action={this.props.acceptRouding}
            isFetching={isFetching}
          />
        ) : null}

        {modalDivergence ? (
          <ModalCfop
            type="primary"
            modalKey={3}
            title="Manter divergência. Gerar planilha de detalhamento das receitas apuradas pelo sistema"
            caption="A RECEITA APURADA PELO SISTEMA ESTÁ DIFERENTE DA RECEITA DECLARADA ORIGINALMENTE NO PGDAS-D. Prosseguindo 
          desta maneira, o sistema gerará apenas a planilha de detalhamento das receitas, mas não realizará a apuração do 
          crédito ou os valores para retificação do PGDAS-D. Caberá única e exclusivamente ao usuário realizar a apuração 
          final dos valores a serem eventualmente retificados e/ou restituídos."
            okText="Prosseguir"
            visible={modalDivergence}
            closeModal={this.closeModal}
            action={this.props.acceptDivergence}
          />
        ) : null}

        {modalBlockRouding ? (
          <ModalCfop
            type="danger"
            modalKey={4}
            title="DIFERENÇA ENTRE RECEITA DECLARADA X RECEITA APURADA"
            caption={
              <span>
                Foi apurada uma diferença maior que 10% entre a Receita Bruta
                declarada no PGDAS-D e a Receita Bruta apurada pelo
                e-Recuperador. Verifique por favor: <br />
                <br />
                <strong>1)</strong> A lista dos CFOP´s considerados como
                Receita; <br />
                <strong>2)</strong> Se os Descontos e Devoluções foram
                considerados (ou não) para a apuração da Receita; <br />
                <strong>3)</strong> Se os arquivos eletrônicos carregados para o
                sistema contêm toda a movimentação da empresa.
                <br />
                <br />
                Se desejar prosseguir mesmo havendo divergência, o sistema
                gerará apenas a planilha de detalhamento das receitas, não
                realizando a apuração do crédito ou os valores para retificação
                do PGDAS-D.
              </span>
            }
            okText="Prosseguir"
            visible={modalBlockRouding}
            closeModal={this.closeModal}
            action={this.props.acceptDivergence}
          />
        ) : null}

        {modalBlockDeclardaMaior ? (
          <ModalCfop
            type="warning"
            modalKey={5}
            title="DIFERENÇA ENTRE RECEITA DECLARADA X RECEITA APURADA"
            caption={
              <span>
                A receita Bruta apurada pelo sistema está menor que a Receita
                Bruta declarada no PGDAS-D. Deseja prosseguir e verificar se,
                mesmo assim, há créditos a recuperar?
              </span>
            }
            okText="Prosseguir"
            visible={modalBlockDeclardaMaior}
            closeModal={this.closeModal}
            action={this.props.acceptRouding}
          />
        ) : null}

        <div className="cfop__header">
          <Row gutter={16}>
            <Col span={8}>
              <Card
                className="ant-card--data"
                title="Receita declarada"
                bordered={false}
              >
                <span>
                  {(data &&
                    data.Diferenca &&
                    numberToReal(data.Diferenca.ReceitaDeclarada)) ||
                    "-"}
                </span>
                <i className="fas fa-file-invoice-dollar icon" />
              </Card>
            </Col>
            <Col span={8}>
              <Card
                className="ant-card--data"
                title="Receita apurada"
                bordered={false}
              >
                <span>
                  {(data &&
                    data.Diferenca &&
                    numberToReal(data.Diferenca.ReceitaApurada)) ||
                    "-"}
                </span>
                <i className="fas fa-file-invoice icon" />
              </Card>
            </Col>
            <Col span={8}>
              <Card
                className="ant-card--data"
                title="Diferença das receitas"
                bordered={false}
              >
                <span>
                  {(data &&
                    data.Diferenca &&
                    numberToReal(data.Diferenca.ValorDiferenca)) ||
                    "-"}
                </span>
                <i className="fas fa-not-equal icon" />
              </Card>
            </Col>
          </Row>
        </div>

        {DuplicidadeMovimentacao && (ValidarNfce || ValidarNfe) ? (
          <DrawerMovement data={data} id={id} />
        ) : (
          <>
            <div className="mb-2">
              <Switch
                defaultChecked={ConsiderarDesconto}
                checkedChildren="Sim"
                unCheckedChildren="Não"
                loading={isFetching ? true : false}
                onChange={() => this.props.setDiscount(id)}
              />
              <label className="ml-2 mr-3">Considerar desconto? </label>

              <Switch
                defaultChecked={ConsiderarDevolucao}
                checkedChildren="Sim"
                unCheckedChildren="Não"
                loading={isFetching ? true : false}
                onChange={() => this.props.setDevolution(id)}
              />
              <label className="ml-2 mr-3">
                Considerar entrada de devolução?
                <strong>{numberToReal(ValorTotalDevolucao)}</strong>
              </label>

              <Switch
                defaultChecked={ConsiderarFrete}
                checkedChildren="Sim"
                unCheckedChildren="Não"
                loading={isFetching ? true : false}
                onChange={() => this.props.setFreight(id)}
              />
              <label className="ml-2 mr-3">Considerar frete? </label>

              <Switch
                defaultChecked={ConsiderarValorAcrescido}
                checkedChildren="Sim"
                unCheckedChildren="Não"
                loading={isFetching ? true : false}
                onChange={() => this.props.setAddition(id)}
              />
              <label className="ml-2 mr-3">
                Considerar valores de acréscimos?{" "}
              </label>

              <Switch
                defaultChecked={ConsiderarOutrasDespesas}
                checkedChildren="Sim"
                unCheckedChildren="Não"
                loading={isFetching ? true : false}
                onChange={() => this.props.setOutrasDespesas(id)}
              />
              <label className="ml-2 mr-3">
                Considerar valores de Outras despesas Acessórias?
                <strong>{numberToReal(ValorTotalOutrasDespesas)}</strong>
              </label>
            </div>
            <TableTransfer
              className="ant-transfer--custom"
              dataSource={newList}
              targetKeys={targetKeys}
              locale={{ itemUnit: "item", itemsUnit: "itens" }}
              titles={["Considera Receita", "Não Considera Receita"]}
              disabled={isFetching ? true : false}
              showSearch={true}
              onChange={this.handleChange}
              filterOption={(inputValue, item) =>
                item.cfop.indexOf(inputValue) !== -1
              }
              leftColumns={columns}
              rightColumns={columns}
            />

            <div className="cfop__footer">
              <Button className="btn-cancel" onClick={() => this.openModal(1)}>
                Interromper apuração
              </Button>
              <Button className="btn-warning" onClick={() => this.openModal(3)}>
                Manter divergência e gerar planilha de detalhamento das receitas
                apuradas pelo sistema
              </Button>
              <Button
                className="btn-ok"
                onClick={() => {
                  if (data.DeclaradaMaior) {
                    this.openModal(5);
                  } else {
                    this.openModal(data.BloquearArredondamento ? 4 : 2);
                  }
                }}
              >
                Prosseguir com a apuração do crédito considerando a receita
                total originalmente declarada no PGDAS-D
              </Button>
            </div>
          </>
        )}
      </div>
    );
  }
}

const loadingChangeRecipe = createLoadingSelector(["CHANGE_RECIPE_CFOP"]),
  loadingDelete = createLoadingSelector(["DELETE_RESULT"]),
  loadingRouding = createLoadingSelector(["ACCEPT_ROUDING"]),
  loadingDivergence = createLoadingSelector(["ACCEPT_DIVERGENCE"]),
  loadingSetDiscount = createLoadingSelector(["SET_DISCOUNT"]),
  loadingSetFreight = createLoadingSelector(["SET_FREIGHT"]),
  loadingSetDevolution = createLoadingSelector(["SET_DEVOLUTION"]),
  loadingSetAddition = createLoadingSelector(["SET_ADDITION"]),
  loadingSetOutrasDespesas = createLoadingSelector(["SET_OUTRAS_DESPESAS"]);

const mapStateToProps = (state) => ({
  data: state.results.data,
  statusDelete: state.results.status,
  isFetching:
    loadingChangeRecipe(state) ||
    loadingDelete(state) ||
    loadingRouding(state) ||
    loadingDivergence(state) ||
    loadingSetDiscount(state) ||
    loadingSetFreight(state) ||
    loadingSetDevolution(state) ||
    loadingSetAddition(state) ||
    loadingSetOutrasDespesas(state)
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      deleteResult,
      changeRecipeCfop,
      acceptRouding,
      acceptDivergence,
      setDiscount,
      setFreight,
      setDevolution,
      setAddition,
      setOutrasDespesas
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Cfop));
